import Splide from "@splidejs/splide";
import carouselSnapshots from "./modules/carouselSnapshots.js";
import DemoBar from "./modules/demo-bar.js";
import disableScreen from "./modules/disableScreen.js";
import gameLauncher from "./modules/game-launcher.js";
import gameReview from "./modules/gameReview.js";
import gridIcons from "./modules/gridIcons.js";
import itemViewEvent from "./modules/itemViewEvent.js";
import reportPopup from "./modules/report-popup.js";
import snapshotView from "./modules/snapshotView.js";
import LobbyApi from "./modules/LobbyAPI.js";

gameLauncher();
new DemoBar();
gameReview().init();
itemViewEvent();
gridIcons();
reportPopup();
LobbyApi();

// Hack to force 16:9 aspect ratio on iframes that have the class .screen__iframe--force169
const forced169iframe = document.querySelector('.screen__iframe--force169');
if (forced169iframe) {
    const forced169screen = forced169iframe.closest('.screen');
    new ResizeObserver(() => {
        const isPortrait = forced169screen.clientWidth < forced169screen.clientHeight;
        forced169screen.dataset.mode = isPortrait ? 'portrait' : 'landscape';
    }).observe(forced169screen);
}

//disableScreen({ title: "test", message: "test", ctaText: "Aceptar", ctaLink: "#", cancelText: "Cancelar", cancelLink: "/"})
window.disableScreen = disableScreen;

function carouselSnapDedicated() {
	const carouselEls = document.querySelectorAll(".snapshotCarousel.splide");
	if (!carouselEls.length) return;

	carouselEls.forEach((carouselEl) => {
		var carousel = new Splide(carouselEl, {
			arrows: true,
			autoHeight: false,
			perPage: 1,
			padding: 0,
			type:"loop",
			autoplay: true,
			perMove: 1,
			gap: 0,
			pagination: false,
		} );
		carousel.mount();
	});
}

function carouselSymbolDedicated() {
	const carouselEl = document.querySelector(".symbolCarousel.splide");
	if (!carouselEl) return;
	
	var carousel = new Splide(carouselEl, {		
		arrows: true,
		autoHeight: true,
		perPage: 2,
		padding: 0,
		type: "loop",
		perMove: 1,
		gap: 9,		
        pagination: false,
	} );
	carousel.mount();
}

function caracteristicasPopup() {
	const popup = document.querySelector(".popup-caracteristicas");
	if(!popup) return;

	const infoBtn = document.querySelector(".info-button");
	const closeBtns = popup.querySelectorAll(".closeBtn")

	infoBtn.addEventListener("click", ()=>popup.classList.remove("d-none"))

	closeBtns.forEach(el=>el.addEventListener("click", ()=>popup.classList.add("d-none")))
}

caracteristicasPopup()
carouselSnapDedicated()
carouselSymbolDedicated()
